import { I18nProvider } from "react-aria";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router";

import { router } from "@/app/router";
import { SessionBootstrap } from "@/app/SessionBootstrap";
import { store } from "@/app/store";

export function AppProviders() {
  return (
    <Provider store={store}>
      <I18nProvider locale="zh-CN">
        <SessionBootstrap>
          <RouterProvider router={router} />
        </SessionBootstrap>
      </I18nProvider>
    </Provider>
  );
}
